"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment/moment"));

// eslint-disable-next-line no-undef
hubspot.define('moment', [], function () {
  return _moment.default;
});
var _default = _moment.default;
exports.default = _default;
module.exports = exports.default;